import $ from "jquery";

// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

$('.features_slider__desktop__list li').on('mouseenter', function(){
  var index = $(this).index();
  $('.features_slider__desktop_bottom ul li').removeClass('active');
  $('.features_slider__desktop_bottom ul li').eq(index).addClass('active');
  $('.features-slider-image-desktop').css({'display':'none'});
});

$('.features_slider__desktop__list li').on('mouseleave', function(){
  $('.features_slider__desktop_bottom ul li').removeClass('active');
  $('.features-slider-image-desktop').css({'display':'block'});
});


// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

$('.features_slider__mobile__slider').each(function(){
  var $element = $(this);
  // var $scrollbar = $(this).parent().find('.swiper-scrollbar');
  var $pagination = $(this).find('.swiper-pagination');
  
  var sdjkfls = new Swiper($element[0], {
    slidesPerView: 1,
    spaceBetween: 24,
    autoHeight: true,
    pagination: {
      el: $pagination[0],
      clickable: true,
    },
  });


  $('.features_slide__text_icon').on('click', function(){
    var index = $(this).index();
    sdjkfls.slideTo(index + 1);
  });

});

